import { render, staticRenderFns } from "./list-segnalazioni.vue?vue&type=template&id=d59df870&"
import script from "./list-segnalazioni.vue?vue&type=script&lang=js&"
export * from "./list-segnalazioni.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports